// import { useCallback, useState } from 'react'

// export const useFormReset = () => {
//     const [submittedBarcode, setSubmittedBarcode] = useState<any>(undefined)

//     // This function clears the form state
//     const handleFormReset = useCallback(() => {
//         setSubmittedBarcode(undefined)
//     }, [])

//     return {
//         submittedBarcode,
//         setSubmittedBarcode,
//         handleFormReset,
//     }
// }

import { useState } from 'react'
import { z } from 'zod'

// Assuming FormSchema is already defined
export const useFormReset = <T extends z.ZodTypeAny>(
    initialValue: z.infer<T> | undefined
) => {
    const [submittedBarcode, setSubmittedBarcode] = useState<
        z.infer<T> | undefined
    >(initialValue)

    // Reset logic to clear the form
    const handleFormReset = () => {
        setSubmittedBarcode(undefined) // Clear the barcode data
    }

    return { submittedBarcode, setSubmittedBarcode, handleFormReset }
}
